// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Available statuses
export const STATUSES = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SAVING: 'SAVING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  CREATED: 'CREATED',
};
